import { useEffect } from 'react'
import { Dialog } from '@bosch/react-frok'
import { useModal } from '@/contexts/modalContext'
import useTouchScrollLock from '@/hooks/useTouchScrollLock'

import './Modal.scss'

// the dialog, the menu of a select in it, and the sheet that picks a line
const MODAL_SCROLL_SCOPE = '.a-box--modal, [class*="fms__menu"], .line-picker-sheet'

const Modal = () => {
    const { modal, hideModal, data, isConfirmButtonDisabled } = useModal()
    const isOpen = !!modal

    // the page behind a dialog does not scroll (see Modal.scss)
    useEffect(() => {
        if (!isOpen) return
        document.documentElement.classList.add('modal-open')
        return () => document.documentElement.classList.remove('modal-open')
    }, [isOpen])
    useTouchScrollLock(isOpen, MODAL_SCROLL_SCOPE)

    if (!modal) {
        return null
    }

    const showConfirmButton = modal.showConfirmButton !== false
    const showCancelButton = modal.showCancelButton !== false && !!modal.cancelLabel

    return (
        <Dialog
            open={true}
            variant={modal.variant}
            modal={true}
            title={modal.title}
            onClose={() => hideModal()}
            onConfirm={showConfirmButton ? () => modal.onConfirmClick?.(data) : undefined}
            confirmButton={showConfirmButton ? {
                disabled: isConfirmButtonDisabled,
                className: 'modal-confirm-button',
            } : undefined}
            confirmLabel={showConfirmButton ? modal.confirmLabel || 'Confirm' : undefined}
            cancelLabel={showCancelButton ? modal.cancelLabel : undefined}
            cancelButton={showCancelButton ? { className: 'modal-cancel-button' } : undefined}
            onCancel={showCancelButton ? modal.onCancelClick || hideModal : undefined}
        >
            {modal.content}
        </Dialog>
    )
}

export default Modal
